import axiosClient from "api/apiClient";

export interface IOptions {
    page: string;
    sort?: string;
    order?: string;
    search?: string;
    startDate?: string;
    endDate?: string;
    type: string;
    export?: boolean;
    pageType?: string,
    pageTypeId?: string,
    item_type_id?: string,
    tab_type?: string,
    test_grade?: string,
    test_type?: string,
    test_score?: any[],
}

export const APIGetActiveTests = (options: IOptions) => {
    let sort = "";
    let search = "";
    let params = "";
    if (options.hasOwnProperty("sort")) {
        if (options.order === "asc") {
            sort = "&sort=" + options.sort;
        } else if (options.order === "desc") {
            sort = "&sort=-" + options.sort;
        }
    }
    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.search;
    }

    if (options.type === "school") {
        params = "tests/list/school";
    } else if (options.type === "bac") {
        params = "tests/list/bac";
    } else if (options.type === "evaluate") {
        params = "tests/list/evaluate";
    } else if (options.type === "training") {
        params = "tests/list/training";
    } else if (options.type === "literacy") {
        params = "tests/list/literacy";
    } else if (options.type === "digitalLiteracy") {
        params = "tests/list/digital-literacy";
    } else if (options.type === "customTest") {
        params = "tests/list/personal";
    } else if (options.type === "numericLiteracy") {
        params = "tests/list/numerical-literacy";
    } else if (options.type === "scientificLiteracy") {
        params = "tests/list/science-literacy";
    }

    return axiosClient.post(`/${params}${options.page}${search}${sort}`);
};

export const APIGetTestsHistory = (options: IOptions) => {
    let sort = "";
    let search = "";
    let exportData = "";
    let dateInterval = "";
    let pageType = "";
    let pageTypeId = "";
    let params = "";
    let itemTypeId = "";
    let tabType = "";
    let gradeId = "";
    let score = "";

    if (options.hasOwnProperty("sort")) {
        if (options.order === "asc") {
            sort = "&sort=" + options.sort;
        } else if (options.order === "desc") {
            sort = "&sort=-" + options.sort;
        }
    }
    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.search;
    }

    if (options.hasOwnProperty("startDate") && options.hasOwnProperty("endDate")) {
        dateInterval = "&start_date=" + options.startDate + "&end_date=" + options.endDate;
    }

    if (options.hasOwnProperty("export")) {
        if (options.export) {
            exportData = "&export=true";
        }
    }

    if (options.hasOwnProperty("pageType")) {
        if (options.pageType !== undefined) {
            pageType = "&pageType=" + options.pageType;
        }
    }

    if (options.hasOwnProperty("pageTypeId")) {
        if (options.pageTypeId !== undefined) {
            pageTypeId = "&pageTypeId=" + options.pageTypeId;
        }
    }

    if (options.hasOwnProperty("test_type")) {
        if (options.test_type !== undefined) {
            itemTypeId = "&item_type_id=" + options.test_type;
        }
    }

    if (options.hasOwnProperty("test_grade")) {
        if (options.test_grade !== undefined) {
            gradeId = "&grade_id=" + options.test_grade;
        }
    }

    if(options.hasOwnProperty("tab_type")) {
        if(options.tab_type !== undefined) {
            tabType = options.tab_type;
        }
    }

    if (options.hasOwnProperty("test_score")) {
        if (options.test_score) {
            score = "&score=" + options.test_score[1] + "&score_operator=" + options.test_score[0];
        }
    }

    if(tabType === "history") {
        if (options.type === "school") {
            params = "tests/history/school";
        } else if (options.type === "bac") {
            params = "tests/history/bac";
        } else if (options.type === "evaluate") {
            params = "tests/history/evaluate";
        } else if (options.type === "training") {
            params = "tests/history/training";
        } else if (options.type === "literacy") {
            params = "tests/history/literacy";
        } else if (options.type === "digitalLiteracy") {
            params = "tests/history/digital-literacy";
        } else if (options.type === "customTest") {
            params = "tests/history/personal";
        } else if (options.type === "numericLiteracy") {
            params = "tests/history/numerical-literacy";
        } else if (options.type === "scientificLiteracy") {
            params = "tests/history/science-literacy";
        }
    } else if(tabType === "archives") {
        if (options.type === "school") {
            params = "tests/archives/school";
        } else if (options.type === "bac") {
            params = "tests/archives/bac";
        } else if (options.type === "evaluate") {
            params = "tests/archives/evaluate";
        } else if (options.type === "training") {
            params = "tests/archives/training";
        } else if (options.type === "literacy") {
            params = "tests/archives/literacy";
        } else if (options.type === "digitalLiteracy") {
            params = "tests/archives/digital-literacy";
        } else if (options.type === "numericLiteracy") {
            params = "tests/archives/numerical-literacy";
        } else if (options.type === "scientificLiteracy") {
            params = "tests/archives/science-literacy";
        }  else if (options.type === "customTest") {
            params = "tests/archives/personal";
        }
    }

    return axiosClient.post(`/${params}${options.page}${search}${sort}${dateInterval}${exportData}${pageType}${pageTypeId}${itemTypeId}${gradeId}${score}`);
};